








































































































































import {Vue, Component, Ref} from "vue-property-decorator";
import VueApexCharts from 'vue-apexcharts';
import axios from 'axios';
import {CodeJar} from 'codejar'
import * as prism from 'prismjs';

// require('prismjs/components/prism-regex.js')

type StatsResponse = {
  stats: Array<Stat>
}
type Stat = {
  date: string,
  count: number,
  new: number,
  unique: number
}

type Site = {
  id: number,
  code: string,
  domain: string,
  event_id: string,
  requests: number,
  views: number,
  users: number,
  new_users: number,
  created_at: string,
}

type SitesModel = {
  headers: any
  data: Array<Site>
  loading: boolean
}

type SitesResponse = {
  sites: Array<Site>
}

declare global {
  interface Date {
    addDays(days: number): Date

    addMillis(millis: number): Date
  }
}

Date.prototype.addDays = function (days: number): Date {
  this.setTime(this.getTime() + (days * 24 * 60 * 60 * 1000))
  return this
}

Date.prototype.addMillis = function (millis: number): Date {
  this.setTime(this.getTime() + (millis))
  return this
}

@Component({
  components: {
    'v-chart': VueApexCharts
  }
})
export default class Sites extends Vue {
  @Ref('site_snippet') siteSnippetElement: any
  @Ref('site_config') siteConfigElement: any
  @Ref('site_event') siteEventElement: any
  @Ref('code_edit') codeEditorDiv!: HTMLDivElement

  private code_text!: string
  jar!: CodeJar

  private site_info_domain: string = 'domain'
  private site_info_id: string = 'id'

  private site_info_dialog: boolean = false
  private create_dialog: boolean = false
  private new_site: Site = {
    domain: ''
  } as Site
  private chartOptions: any = {
    chart: {
      id: 'vuechart-example'
    },
    xaxis: {
      type: "datetime",
    }
  }
  series: any = []

  private date_menu: boolean = false
  private date: Array<string> = [
    (new Date()).addDays(-7).toISOString().substr(0, 10),
    (new Date()).toISOString().substr(0, 10),
  ]

  private sites: SitesModel = {
    headers: [
      {
        text: "Domain",
        value: "domain"
      },
      {
        text: "Requests",
        value: "requests"
      },
      {
        text: "Views",
        value: "views"
      },
      {
        text: "Users",
        value: "users"
      },
      {
        text: "New users",
        value: "new_users"
      },
      {
        text: "Created",
        value: "created_at"
      },
      {
        text: "Actions",
        value: "actions",
        align: "right",
        sortable: false
      }
    ],
    data: [] as Array<Site>,
    loading: true,
  }

  // @Watch('code_text', {})
  // myCodeChanged(newCode: string, oldCode: string) {
  //   console.log("code changed:", newCode, oldCode)
  //   this.jar.updateCode(this.code_text)
  // }


  updateCode(newString: string) {
    this.code_text = newString;
  }

  mounted() {
    this.$store.dispatch('set_title', 'Sites')
    this.update_stats()
  }

  update_stats() {
    axios
        .get<StatsResponse>('/api/v1/stats', {
          params: {
            from: new Date(this.date[0]+" ").toISOString(),
            to: new Date(this.date[1]+" ").addDays(1).addMillis(-1).toISOString(),
            tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
          }
        })
        .then(response => {
          let counts: any = [];
          let news: any = [];
          let uniques: any = [];
          // console.log(response.data)
          // let d = new Date(response.data.stats[0].date);
          response.data.stats.forEach(function (stat: Stat) {
            counts.push([
              (new Date(stat.date)).getTime(),
              stat.count
            ])
            news.push([
              (new Date(stat.date)).getTime(),
              stat.new
            ])
            uniques.push([
              (new Date(stat.date)).getTime(),
              stat.unique
            ])
          })
          this.series = [{
            name: "calls",
            data: counts,
          }, {
            name: "new users",
            data: news,
          }, {
            name: "unique users",
            data: uniques,
          }]
          // let date = new Date(response.data.stats[0].date)
          // console.log(date.getTime())
        })
    axios
        .get<SitesResponse>('/api/v1/sites', {
          params: {
            from: this.DateString(new Date(this.date[0]+" ")) ,
            to: this.DateString(new Date(this.date[1]+" ").addDays(1).addMillis(-1)),
            tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
          }
        })
        .then(response => {
          this.sites.data = response.data.sites || []
          this.sites.loading = false
        })
  }
  public DateString(d: Date){
    function pad(n: number) {
      return n<10 ? '0'+n : n
    }
    return d.getFullYear()+'-'
        + pad(d.getMonth()+1)+'-'
        + pad(d.getDate())+'T'
        + pad(d.getHours())+':'
        + pad(d.getMinutes())+':'
        + pad(d.getSeconds())+'Z'
  }

  create() {
    axios
        .post<Site>('/api/v1/sites', this.new_site)
        .then(response => {
          this.sites.data.push(response.data)
          this.create_dialog = false
        })
  }

  date_picker_change() {
    this.date_menu = this.date.length === 1
    if (this.date.length != 2) return

    if (new Date(this.date[1]) < new Date(this.date[0])) {
      let d = this.date[1]
      this.date[1] = this.date[0]
      this.date[0] = d
    }

    this.update_stats()
  }

  copy_site_snippet() {
    // console.log(this.siteSnippetElement.$el)
    let ta = this.siteSnippetElement.$el.querySelector('textarea')
    ta.select()
    // console.log(ta)
    // console.log(document.execCommand('copy'))
    document.execCommand('copy')
  }

  copy_site_config() {
    let ta = this.siteConfigElement.$el.querySelector('textarea')
    ta.select()
    document.execCommand('copy')
  }

  copy_site_event() {
    let ta = this.siteEventElement.$el.querySelector('textarea')
    ta.select()
    document.execCommand('copy')
  }

  get site_snippet(): string {
    let spinnet =
        "window.digitalks=window.digitalks||new function(){var t=this;t._e=[],t._c={},t.config=function(c){var i;t._c=c,t._c.script_id?((i=document.createElement(\"script\")).src=\"//cdn-px-v1.metrix.az/v1/scripts/\"+t._c.script_id+\"/track.js?&cb=\"+Math.random(),i.async=!0,document.head.appendChild(i)):console.error(\"digitalks: script_id cannot be empty!\")};[\"track\",\"identify\"].forEach(function(c){t[c]=function(){t._e.push([c].concat(Array.prototype.slice.call(arguments,0)))}})};"

    let config = 'digitalks.config({\n' +
        '    script_id: "' + this.site_info_id + '",\n' +
        '    page_url: location.href,\n' +
        '    referrer: document.referrer\n' +
        '})';

    return '<script>\n' + spinnet + '\n\n' + config + '\n<' + '/' + 'script>'
  }

  get site_config(): string {
    return 'digitalks.config({\n' +
        '    script_id: "' + this.site_info_id + '",\n' +
        '    page_url: location.href,\n' +
        '    referrer: document.referrer\n' +
        '})'
  }

  get site_event(): string {
    return '<script>\n' +
        'digitalks.track("basket", {\n' +
        '    product: 123,\n' +
        '    price: 702.1,\n' +
        '    currency: "USD",\n' +
        '})\n' +
        '<' + '/script>'
  }

  site_info(site: Site) {
    // console.log(site)
    this.site_info_id = site.event_id
    this.site_info_domain = site.domain
    this.site_info_dialog = true

    if (this.jar) {
      this.code_text = site.code || '// Custom code goes here'
      this.jar.updateCode(this.code_text)
    } else {
      setTimeout(() => {
        this.jar = CodeJar(this.codeEditorDiv,
            // withLineNumbers(Prism.highlightElement),
            (e: HTMLElement) => {
              prism.highlightElement(e);
            }
        );
        this.code_text = site.code || '// Custom code goes here'
        this.jar.updateCode(this.code_text)
        this.jar.onUpdate(this.updateCode);
      }, 1000)
    }
  }

  site_by_segment(site: Site) {
    this.$router.push({
      name: 'Site',
      params: {
        id: String(site.id)
      }
    })
  }

  site_pages(site: Site) {
    this.$router.push({
      name: 'Site Pages',
      params: {
        site_id: String(site.id)
      }
    })
  }

  delete_site(item: Site) {
    axios
        .delete<any>(
            '/api/v1/sites/' + item.id)
        .then(() => {
          this.sites.data = this.sites.data.filter(it => it.id != item.id)
        })
  }

  saveCodeEvent(e: any) {
    e.preventDefault()
    axios
        .post<any>(
            '/api/v1/events/' + this.site_info_id + '/code', {
              code: this.code_text
            })
        .then(() => {
        })

    let s = this.sites.data.find(
        site => site.event_id == this.site_info_id
    )
    if (s) {
      s.code = this.code_text
    }
  }
}

